import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import { useModal } from '../../../../../hooks/useModal';

export default function useHandleBuyRequest() {
  const { closeModal } = useModal();

  useRequestsHandlerData([
    {
      address: 'requestsWishBuyGift',
      settled() {
        closeModal('all');
      },
    },
  ]);
}
